import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Set normal behavior period", -1 /* HOISTED */)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "q-mr-xl q-ml-md" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "row items-center justify-end" }
const _hoisted_6 = { class: "row items-center justify-end" }
const _hoisted_7 = { class: "q-mr-xl q-ml-md q-mt-md" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "row items-center justify-end" }
const _hoisted_10 = { class: "row items-center justify-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Validate", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.getDisplayNormalBehaviorPopin,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.getDisplayNormalBehaviorPopin) = $event)),
    onBeforeShow: _ctx.beforeShow
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"600px","max-width":"100vw","overflow":"scroll"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_q_space),
              _createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: "",
                dense: "",
                onClick: _ctx.onClose
              }, null, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                class: "column",
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent","stop"]))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, "Start date (yyyyy/mm/dd hh:mm) - UTC " + _toDisplayString(_ctx.utcOffsetStartDate), 1 /* TEXT */),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event)),
                      outlined: ""
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qDateProxy",
                              cover: "",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.startDate,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                                  options: _ctx.startDateOptions,
                                  mask: "YYYY-MM-DD HH:mm"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_5, [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        label: "Close",
                                        color: "primary",
                                        flat: ""
                                      }, null, 512 /* NEED_PATCH */), [
                                        [_directive_close_popup]
                                      ])
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                              ]),
                              _: 1 /* STABLE */
                            }, 512 /* NEED_PATCH */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.startDate,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                                  mask: "YYYY-MM-DD HH:mm",
                                  options: _ctx.startTimeOptions,
                                  format24h: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        label: "Close",
                                        color: "primary",
                                        flat: ""
                                      }, null, 512 /* NEED_PATCH */), [
                                        [_directive_close_popup]
                                      ])
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, "End date (yyyy/mm/dd hh:mm) - UTC " + _toDisplayString(_ctx.utcOffsetEndDate), 1 /* TEXT */),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event)),
                      outlined: ""
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "event",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              ref: "qDateProxy",
                              cover: "",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _ctx.endDate,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                                  options: _ctx.endDateOptions,
                                  mask: "YYYY-MM-DD HH:mm"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        label: "Close",
                                        color: "primary",
                                        flat: ""
                                      }, null, 512 /* NEED_PATCH */), [
                                        [_directive_close_popup]
                                      ])
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                              ]),
                              _: 1 /* STABLE */
                            }, 512 /* NEED_PATCH */)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "access_time",
                          class: "cursor-pointer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_popup_proxy, {
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_time, {
                                  modelValue: _ctx.endDate,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                                  mask: "YYYY-MM-DD HH:mm",
                                  options: _ctx.endTimeOptions,
                                  format24h: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_10, [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        label: "Close",
                                        color: "primary",
                                        flat: ""
                                      }, null, 512 /* NEED_PATCH */), [
                                        [_directive_close_popup]
                                      ])
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_q_card_actions, {
                  class: "q-mt-lg",
                  align: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      class: "action-button",
                      disable: !_ctx.startDate || !_ctx.endDate,
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disable"])
                  ]),
                  _: 1 /* STABLE */
                })
              ], 32 /* HYDRATE_EVENTS */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onBeforeShow"]))
}